import * as React from 'react';
import { useState } from "react";
import ButtonMenuItem from "../components/buttonMenuItem";
import DropdownMenu from "../components/dropdownMenu";
import IconFontAwesome from "../components/iconFontAwesome";
import { getByteSize, isFunction } from "../helpers/utils";
import { type AssetData, AssetMode } from "./asset.interface";
import AssetInfoPill from "./assetInfoPill.tsx";
import { getImgUrl } from "./assetUtils";
import BackgroundCheckered from "./backgroundCheckered";
import { MenuItem, MenuItems, MenuSeparator } from '@headlessui/react';
import { clsx } from 'clsx';
import Lightbox from "yet-another-react-lightbox";
// import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { useCopyToClipboard } from "@uidotdev/usehooks";

type Props = {
	openModalEdit?: Function,
	onSelect?: Function,
	handleDelete?: Function,
	asset: AssetData
}

function Asset({ openModalEdit, onSelect, handleDelete, asset }: Props) {

	const mode = (isFunction(onSelect)) ? 'select' : 'edit';
	const [_copiedText, copy] = useCopyToClipboard();

	const [open, setOpen] = useState(false);
	// const zoomRef = useRef(null);

	function renderFile() {
		let image = (
			<div className="h-full flex justify-center items-center">
				<IconFontAwesome className={clsx("text-8xl !text-grey-400", getFileIconClass())}/>
			</div>
		);

		if (mode === 'select') {
			return (<a href="#" onClick={() => setOpen(true)}>{image}</a>);
		}

		return image;
	}

	function getFileIconClass() {
		switch (asset.fileMimeExtension) {
			case 'pdf': return 'icon-file-pdf';
			case 'docx':
			case 'doc': return 'icon-file-word';
			case 'xlsx':
			case 'xls': return 'icon-file-excel';
			case 'pptx':
			case 'ppt': return 'icon-file-powerpoint';
			case 'zip':
			case '7z':
			case 'rar': return 'icon-file-zipper';
		}

		return 'icon-file';
	}

	function renderImage() {
		let image = (
			<BackgroundCheckered className="h-[300px]">
				<img
					className="w-auto"
					width="480"
					height="300"
					src={getImgUrl(AssetMode.Media, asset?.id, asset?.filename)}
					alt=""
				/>
			</BackgroundCheckered>
		);

		if (asset.linkView && mode === 'edit') {
			return (
				<a
					href={asset.linkView}
					onClick={(e) => { e.preventDefault(); setOpen(true); }}
					className="cursor-zoom-in"
				>
					{image}
				</a>
			);
		}

		if (mode === 'select') {
			return (<a href="#" onClick={(e) => { e.preventDefault(); onSelect(asset); }}>{image}</a>);
		}

		return image;
	}

	return (
		<>
			<div id={"asset" + asset.id} className="box bg-white relative h-full flex flex-col group rounded-t-md overflow-hidden">
				<div className="border-b border-grey-300 p-2 text-left flex items-center bg-grey-100 gap-0.5">
					{mode === 'select' && <><button onClick={() => onSelect(asset.id)}>Select</button>&nbsp;</>}
					<div className="text-ellipsis overflow-hidden hyphens-none break-keep whitespace-nowrap" title={asset.filename}>{asset.filename}</div>
					<div className="flex grow"/>
					<DropdownMenu>
						<MenuItems className="absolute z-50 right-0 mt-1 min-w-36 box p-2 shadow-lg rounded-md">
							{isFunction(openModalEdit) && <MenuItem>
								<ButtonMenuItem onClick={() => { openModalEdit(); }} icon="icon-eye">Edit</ButtonMenuItem>
							</MenuItem>}
							{asset.linkDownload && <MenuItem>
								<ButtonMenuItem onClick={() => { window.open(asset.linkDownload); }} icon="icon-download">Download</ButtonMenuItem>
							</MenuItem>}

							{asset.linkView && <MenuItem>
								<ButtonMenuItem onClick={() => {copy(asset.linkView); }} icon="icon-copy">Copy link</ButtonMenuItem>
							</MenuItem>}

							{isFunction(handleDelete) && <><MenuSeparator className="my-1 h-px bg-grey-400"/>
							<MenuItem>
								<ButtonMenuItem onClick={() => { handleDelete() }} icon="icon-trash">Delete</ButtonMenuItem>
							</MenuItem></>}
						</MenuItems>
					</DropdownMenu>
				</div>

				<div className="flex-grow"/>

				<div className="h-[300px] relative" style={{
					backgroundColor: asset.colorBg ? asset.colorBg : "transparent"
				}}>
					{asset.isImage ? renderImage() : renderFile()}

					<div className="opacity-0 group-hover:opacity-100 ease-mine duration-300 transition-opacity absolute bottom-2 inset-x-2 text-sm">
						<div className="flex flex-wrap gap-1">
							<AssetInfoPill>{asset.fileMimeExtension}</AssetInfoPill>
							{asset.isImage && <AssetInfoPill className="break-keep">
								{asset.width}<span className="inline-block px-0.5 align-text-bottom">x</span>{asset.height}
							</AssetInfoPill>}
							<AssetInfoPill>{getByteSize(asset.fileSize)}</AssetInfoPill>
							{asset.description && <AssetInfoPill>{asset.description}</AssetInfoPill>}
						</div>
					</div>
				</div>
			</div>

			<Lightbox
				open={open}
				close={() => setOpen(false)}
				slides={[{ src: asset.linkView }]}
				render={{
					buttonPrev: () => null,
					buttonNext: () => null,
				}}
				// plugins={[Zoom]}
				// zoom={{ ref: zoomRef }}
			/>

			{/*<Dump {...props}/>*/}
			{/*<Dump value={isFunction(onSelect)}/>*/}
			{/*<Dump value={isFunction(openModalEdit)}/>*/}
			{/*<Dump value={(isFunction(onSelect) || isFunction(openModalEdit))}/>*/}
		</>
	);
}

export default Asset;
